module.exports = __webpack_public_path__ + "static/img/choose-your-template.8570ee0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surveys/choose-your-template.png
// module id = 1X3l
// module chunks = 0